import { render, staticRenderFns } from "./PatrolManagement.vue?vue&type=template&id=1b8b0d07&scoped=true"
import script from "./PatrolManagement.vue?vue&type=script&lang=js"
export * from "./PatrolManagement.vue?vue&type=script&lang=js"
import style0 from "./PatrolManagement.vue?vue&type=style&index=0&id=1b8b0d07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8b0d07",
  null
  
)

export default component.exports